import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  hasSeenSearchPulse: boolean;
}

const initialState: UIState = {
  hasSeenSearchPulse: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setHasSeenSearchPulse(state, action: PayloadAction<boolean>) {
      state.hasSeenSearchPulse = action.payload;
    },
  },
});

export const { setHasSeenSearchPulse } = uiSlice.actions;
export default uiSlice.reducer;
